import { FC } from 'react';

export const LegalPage: FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6">
        Privacy Policy and Terms of Service
      </h1>
      <p className="text-sm text-gray-500 mb-10">
        Effective Date: <span className="font-medium">15.04.2025</span>
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          1. Information We Collect
        </h2>
        <p>
          We value your privacy and aim to collect only the minimal data
          necessary to provide our services.
        </p>
        <ul className="list-disc list-inside mt-2">
          <li>
            <strong>Phone Numbers:</strong> When you provide your phone number,
            we collect it solely for the purpose of sending you SMS
            notifications related to your use of our services.
          </li>
          <li>
            <strong>No Other Personal Information:</strong> We do not collect,
            store, or request any other personally identifiable information such
            as your name, email address, physical address, or payment details.
          </li>
          <li>
            <strong>No Cookies or Tracking:</strong> Our website does not use
            cookies, web beacons, or third-party tracking tools to collect
            information about your browsing activity.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          2. How We Use Your Information
        </h2>
        <p>
          The information you provide is used strictly for communication and
          functionality purposes:
        </p>
        <ul className="list-disc list-inside mt-2">
          <li>
            To send SMS notifications relevant to your use of our service (e.g.,
            confirmations, updates, reminders).
          </li>
          <li>
            To provide customer support or notify you of important changes to
            our service.
          </li>
          <li>
            We do <strong>not</strong> use your information for marketing
            purposes.
          </li>
          <li>
            We do <strong>not</strong> share, sell, or rent your phone number to
            any third parties.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">3. SMS Notifications</h2>
        <p>
          By providing your phone number, you consent to receive SMS messages
          from us.
        </p>
        <p className="mt-2">
          You can opt out at any time by replying <strong>STOP</strong> to any
          of our messages. Standard message and data rates may apply depending
          on your mobile carrier.
        </p>
        <p className="mt-2">
          User see clear Call to Action: “By submitting this order, you agree to
          receive SMS updates about your order status. Click Cancel to reject.”
        </p>
        <p className="mt-2">
          We do not use your phone number for any purpose other than sending
          relevant notifications. You will not receive promotional or
          third-party messages.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          4. Text Messaging Disclosure
        </h2>
        <p>
          No mobile information will be shared with third parties/affiliates for
          marketing/promotional purposes. Information sharing to subcontractors
          in support services, such as customer service, is permitted. All other
          use case categories exclude text messaging originator opt-in data and
          consent; this information will not be shared with any third parties.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">5. Data Retention</h2>
        <p>
          We retain your phone number only for as long as it is needed to
          fulfill the purposes for which it was collected. If you opt out of SMS
          communications, your number is removed from our active messaging
          system.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">6. Data Security</h2>
        <p>
          We take appropriate measures to ensure the security of your
          information, including physical, technical, and administrative
          safeguards. While we strive to protect your information, no method of
          transmission over the internet or via mobile networks is 100% secure.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">7. Third-Party Sharing</h2>
        <p>
          We do not share your personal data with any third parties. We do not
          use third-party advertising or analytics services that track you
          across websites.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">8. Your Privacy Rights</h2>
        <p>You have the right to:</p>
        <ul className="list-disc list-inside mt-2">
          <li>Know what personal information we collect and how we use it.</li>
          <li>
            Request that we delete your phone number and any related data from
            our system.
          </li>
          <li>
            Withdraw your consent to receive SMS messages at any time by texting{' '}
            <strong>STOP</strong>.
          </li>
        </ul>
        <p className="mt-2">
          To exercise any of these rights, please contact us using the details
          below.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">9. Children’s Privacy</h2>
        <p>
          Our services are not intended for use by individuals under the age of
          13. We do not knowingly collect any information from children. If we
          become aware that we have inadvertently collected data from a child
          under 13, we will take steps to delete such information.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">
          10. Changes to This Privacy Policy
        </h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes
          in our practices or legal obligations. If changes are made, we will
          update the “Effective Date” and post the new policy on this page. We
          encourage you to review this policy periodically.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">11. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding this Privacy Policy or
          our practices, please reach out to us:
        </p>
        <ul className="mt-2 list-disc list-inside">
          <li>
            Email:{' '}
            <a
              href="mailto:ryan@milkandhoney.land"
              className="text-blue-600 hover:underline"
            >
              ryan@milkandhoney.land
            </a>
          </li>
        </ul>
      </section>
    </div>
  );
};
